import React from 'react';
import { useTranslation } from '../../shared/i18n/i18n-context';

const Thanks = () => {
    const { t } = useTranslation('common');

    return (
        <div>
            <h1>{t('thanks')}</h1>
        </div>
    )
}

export default Thanks;
